<template>
    <div class="personalFiles">
        <!-- 第一个白框里的内容 -->
        <div class="outer-border margin-bottom-three">
            <el-row class="title-border-bottom">
                <div class="b-title fl">
                    个人档案
                    <span>({{ysSpStatus(userInfo.approvalStatus)}})</span>
                </div>
            </el-row>
            <div class="set-padding">
                <el-form ref="form" :model="form" label-width="125px" :rules="rules">
                    <el-row>
                        <el-col :span="18">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="姓名：">
                                        <el-input
                                            size="small"
                                            v-model="form.realName"
                                            maxlength="20"
                                            show-word-limit
                                            placeholder="请输入姓名"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="性别：" prop="gender">
                                        <el-select
                                            size="small"
                                            v-model="form.gender"
                                            placeholder="请选择"
                                        >
                                            <el-option label="男" value="男"></el-option>
                                            <el-option label="女" value="女"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="身份证号:" prop="card">
                                        <el-input
                                            size="small"
                                            v-model="form.card"
                                            placeholder="请输入身份证号..."
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="手机号:" prop="phone">
                                        <el-input
                                            size="small"
                                            disabled
                                            v-model="form.phone"
                                            placeholder="请输入手机号..."
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item label="身份证上传:" class="set-line-height-zero">
                                <div class="upload-wrap fl">
                                    <el-upload
                                        :show-file-list="false"
                                        class="avatar-uploader"
                                        :action="myFileUrl+'dfs/uploadFile'"
                                        :on-success="(res, file) => handleAvatarSuccess(res, file, 'cardFront')"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img
                                            v-if="form.cardFront"
                                            :src="form.cardFront"
                                            class="avatar"
                                        />
                                        <el-button v-else size="small" type="primary">正面上传</el-button>
                                    </el-upload>
                                </div>
                                <div class="upload-wrap fl">
                                    <el-upload
                                        :show-file-list="false"
                                        class="avatar-uploader"
                                        :action="myFileUrl+'dfs/uploadFile'"
                                        :on-success="(res, file) => handleAvatarSuccess(res, file, 'cardReverse')"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img
                                            v-if="form.cardReverse"
                                            :src=" form.cardReverse"
                                            class="avatar"
                                        />
                                        <el-button v-else size="small" type="primary">背面上传</el-button>
                                    </el-upload>
                                </div>
                            </el-form-item>
                              <el-form-item
                                label="上传手持身份证:"
                                class="set-line-height-zero"
                                prop="peopleCardFront"
                                ref="peopleCardFront"
                            >
                                <div class="upload-wrap fl">
                                    <el-upload
                                        :show-file-list="false"
                                        class="avatar-uploader"
                                        :action="myFileUrl+'dfs/uploadFile'"
                                        :on-success="(res, file) => handleAvatarSuccess(res, file, 'peopleCardFront')"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img
                                            v-if="form.peopleCardFront"
                                            :src="form.peopleCardFront"
                                            class="avatar"
                                        />
                                        <img v-else :src="require('@/assets/img/scsz.png')" alt />
                                    </el-upload>
                                </div>
                                <div class="upload-wrap fl">
                                    <el-upload
                                        :show-file-list="false"
                                        class="avatar-uploader"
                                        :action="myFileUrl+'dfs/uploadFile'"
                                        :on-success="(res, file) => handleAvatarSuccess(res, file, 'peopleCardReverse')"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img
                                            v-if="form.peopleCardReverse"
                                            :src=" form.peopleCardReverse"
                                            class="avatar"
                                        />
                                        <img v-else :src="require('@/assets/img/scsf.png')" alt />
                                    </el-upload>
                                </div>
                            </el-form-item>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="邮箱:" prop="email">
                                        <el-input
                                            size="small"
                                            disabled
                                            v-model="form.email"
                                            placeholder="请输入邮箱..."
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="医师证号:" prop="physicianCardNum">
                                        <el-input
                                            size="small"
                                            v-model="form.physicianCardNum"
                                            placeholder="请输入医师证号..."
                                            maxlength="50"
                                            show-word-limit
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item label="医师证照片:" class="set-line-height-zero">
                                <div class="upload-wrap fl">
                                    <el-upload
                                        :show-file-list="false"
                                        class="avatar-uploader"
                                        :action="myFileUrl+'dfs/uploadFile'"
                                        :on-success="(res, file) => handleAvatarSuccess(res, file, 'physicianCardImg')"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img
                                            v-if="form.physicianCardImg"
                                            :src="form.physicianCardImg"
                                            class="avatar"
                                        />
                                        <img v-else :src="require('@/assets/img/add2.png')" alt />
                                    </el-upload>
                                </div>
                            </el-form-item>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="擅长科室:">
                                        <!-- <el-input
                                            size="small"
                                            v-model="form.adeptDepartment"
                                            placeholder="请输入擅长科室..."
                                        ></el-input>-->
                                        <el-select
                                            size="small"
                                            v-model="form.adeptDepartment"
                                            filterable
                                            clearable
                                            placeholder="请选择"
                                        >
                                            <el-option
                                                v-for="item of sclyList"
                                                :key="item.lableTwo"
                                                :value="item.lableTwo"
                                                :label="item.lableTwo"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="所属医院:">
                                        <el-input
                                            size="small"
                                            v-model="form.hospital"
                                            placeholder="请输入所属医院..."
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="科室:">
                                        <el-input
                                            size="small"
                                            v-model="form.department"
                                            placeholder="请输入科室..."
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="职称:">
                                        <el-select
                                            size="small"
                                            v-model="form.title"
                                            filterable
                                            clearable
                                            placeholder="请选择"
                                        >
                                            <el-option
                                                v-for="item of zcList"
                                                :key="item.lableTwo"
                                                :value="item.lableTwo"
                                                :label="item.lableTwo"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item class="headImg">
                                <el-upload
                                    class="avatar-uploader-circle"
                                    :action="myFileUrl+'dfs/uploadFile'"
                                    :show-file-list="false"
                                    :on-success="(res, file) => handleAvatarSuccess(res, file, 'picture')"
                                    :before-upload="beforeAvatarUpload"
                                >
                                    <img
                                        v-if="form.picture"
                                        :src="form.picture"
                                        class="headImg-circle"
                                    />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="简介">
                                <el-input
                                    type="textarea"
                                    placeholder="请输入简介"
                                    v-model.trim="form.introduceMyself"
                                    :autosize="{ minRows: 4, maxRows: 8}"
                                    maxlength="500"
                                    show-word-limit
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="text-center">
                        <el-col :span="24">
                            <el-form-item class="cancle-margin-left">
                                <el-button
                                    type="danger"
                                    @click="submitForm('form')"
                                    class="btn red"
                                >保存</el-button>
                                <!-- <el-button type="danger" @click="resetForm()" class="btn red">取消</el-button> -->
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import rules from "@/common/rules";

export default {
    name: "personalFiles",
    data() {
        const validatePhone = (rule, value, callback) => {
            const val = value.trim();
            if (val === "") {
                callback(new Error("请输入手机号"));
            } else if (!/^1\d{10}$/.test(val)) {
                callback(new Error("请输入正确的手机号"));
            } else {
                callback();
            }
        };
        return {
            rules: {
                id: [
                    {
                        required: true,
                        message: "请输入医师编号",
                        trigger: "blur"
                    }
                ],
                realName: [
                    {
                        required: true,
                        message: "请输入真实姓名",
                        trigger: "blur"
                    }
                ],
                sex: [
                    { required: true, message: "请选择性别", trigger: "blur" }
                ],
                email: [
                    { required: true, message: "请输入邮箱", trigger: "blur" },
                    {
                        type: "email",
                        message: "请输入正确的邮箱地址",
                        trigger: ["blur", "change"]
                    }
                ],
                phone: [
                    {
                        required: true,
                        validator: validatePhone,
                        trigger: "blur"
                    }
                ],
                card: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: "blur"
                    },
                    {
                        validator: rules.FormValidate.Form().ID,
                        trigger: "blur"
                    }
                ],
                physicianCardNum: [
                    {
                        required: true,
                        message: "请输入医师证号",
                        trigger: "blur"
                    },
                    {
                        validator: rules.FormValidate.Form().validateCodeYiNum,
                        trigger: "blur"
                    }
                ]
            },
            userInfo: {},

            form: {
                id: "",
                realName: "",
                phone: "",
                email: "",
                card: "",
                physicianCardNum: "",
                adeptDepartment: "",
                hospital: "",
                title: "",
                department: "",
                sex: "",
                cardFront: "",
                cardReverse: "",
                physicianCardImg: "",
                headImg: "",
                introduceMyself: ""
            }
        };
    },
    methods: {
        //文件上传的格式判断
        beforeAvatarUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 1;
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            if (!isLt1M) {
                this.$message.error("上传图片大小不能超过 1MB!");
            }
            if (!isJPG && !isPNG) {
                this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
            }
            return (isJPG || isPNG) && isLt1M;
        },
        //上传成功
        handleAvatarSuccess(res, file, k) {
            let that = this;
            this.form[k] = res.data;
            if (res.code == 200) {
                that.$message.success("上传成功");
            } else {
                that.$message.error("上传失败");
            }
        },
        //个人档案回显
        infoDisplay() {
            let that = this;
            let url = "physician/getPhysician";
            let params = {
                userId: that.userInfo.id
            };
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        if (res.data) {
                            that.form = res.data;
                        }
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        submitForm(formName) {
            let that = this;
            that.$refs[formName].validate(async valid => {
                if (!valid) return;
                this.$confirm("此操作医师需要重新审核，并将您账号强制退出，是否继续操作？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        let url = "physician/updatePhysicianInfo";
                        that.$http
                            .post(url, that.form)
                            .then(res => {
                                res = res.data;
                                if (res.code == 200) {
                                    // that.$message({
                                    //     type: "success",
                                    //     message: "保存成功!"
                                    // });
                                    sessionStorage.clear();
                                    that.$router.replace({
                                        path: "/ysLogin"
                                    });
                                    // 刷新兄弟组件
                                    // let NewPage =
                                    //     "_empty" +
                                    //     "?time=" +
                                    //     new Date().getTime() / 500;
                                    // this.$router.push(NewPage);
                                    // this.$router.go(-1);
                                } else {
                                    that.$message.error(res.msg);
                                }
                            })
                            .catch(() => {
                            });
                    })
                    .catch(() => {
                        this.infoDisplay();
                    });
            });
        }
    },
    created() {
        this.dataDictionary("ZC");
        this.dataDictionary("SCLY");
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.infoDisplay();
        }
    }
};
</script>

<style scoped>
.avatar-uploader-circle {
    width: 120px;
    height: 120px;
    line-height: 120px;
    border: 1px solid #ddd;
    text-align: center;
    vertical-align: middle;
    border-radius: 50%;
    margin-left: 35px;
}
.upload-wrap {
    width: 181px;
    height: 113px;
    border: 1px solid #d6d6d6;
    margin-right: 20px;
    display: flex;
    align-items: center;
}
.avatar-uploader {
    margin: 0 auto;
}
.yszzp,
.avataryszzp {
    width: 120px;
    height: 140px;
}
.avatar {
    width: 181px;
    height: 113px;
}
.headImg-circle {
    width: 120px;
    height: 120px;
    border-radius: 50%;
}
.set-line-height-zero{
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/JW/personalFiles.vue